import * as React            from 'react';

import { EmailVector       } from 'src/components/vector/email';

import { Typography        } from 'src/components/common/typography';
import { Link              } from 'src/components/common/link';
import { HorizontalDivider } from 'src/components/common/horizontal-divider';

import { Container,
         NoteVariants,
         note_variants     } from 'src/components/features/qmmsg/select-company/note/ui';



type Props = {
  variant: NoteVariants;
  fio: string;
}
export const Note: React.FC<Props> = ({
  variant,
  fio,
}) => {
  const lookAndFeel = note_variants.get(variant)!;

  return (
    <Container lookAndFeel = { lookAndFeel }>
      <EmailVector />
      <HorizontalDivider variant='transparent_10px' />
      <Typography variant = { lookAndFeel.topograhyVariant }>
        Для добавления предприятий<br/> клиента отправьте запрос на
      </Typography>
      <HorizontalDivider variant='transparent_4px' />
      <Link
        variant = { lookAndFeel.linkVariant }
        label = 'ukpp@severstal.com'
        url = {`mailto:ukpp@severstal.com?subject=Требуется добавить клиентов сотруднику СТПК&body=Требуется сотруднику СТПК ${fio} добавить клиентов:`}
      />
    </Container>
  );
};
